import DiagramWithToggleKey from "../shared/DiagramWithToggleKey";
import MethylationDetoxificationPhase1Combined from "./index";

const MethylationDetoxificationPhase1WithToggleKey = props => (
  <DiagramWithToggleKey
    CombinedDiagram={MethylationDetoxificationPhase1Combined}
    keyControlsId="methylation-detoxification-phase1-key"
    {...props}
  />
);

export default MethylationDetoxificationPhase1WithToggleKey;
